import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { publicPath } from '../../utils/canonicalUrl';
import './MarketplaceSearchForm.css';

const PISTOIA = { lat: 43.933, lng: 10.917 };

/** Fondi/assicurazioni in standby: manca tariffario per compagnia. */
const PAGATORI_ATTIVI = [
  { value: 'PRIVATO', label: 'Privatamente' },
  { value: 'SSN', label: 'Con ricetta / SSN (informativo)' },
];

function normalizePagatore(value) {
  return PAGATORI_ATTIVI.some((p) => p.value === value) ? value : 'PRIVATO';
}

/**
 * Form ricerca marketplace (mockup 01) — riusato in home e /ricerca/.
 */
export default function MarketplaceSearchForm({
  initial = {},
  compact = false,
  onSubmitLocal,
}) {
  const navigate = useNavigate();
  const [prestazione, setPrestazione] = useState(initial.prestazione || '');
  const [dove, setDove] = useState(initial.dove || '');
  const [pagatore, setPagatore] = useState(() => normalizePagatore(initial.pagatore));

  const handleSubmit = (e) => {
    e.preventDefault();
    const next = new URLSearchParams();
    if (prestazione.trim()) next.set('prestazione', prestazione.trim());
    if (dove.trim()) next.set('dove', dove.trim());
    next.set('pagatore', normalizePagatore(pagatore));
    // Coordinate solo se l'utente ha indicato una zona (niente Pistoia forzata).
    if (dove.trim()) {
      next.set('lat', String(PISTOIA.lat));
      next.set('lng', String(PISTOIA.lng));
      next.set('raggioKm', '20');
    }
    if (typeof onSubmitLocal === 'function') {
      onSubmitLocal(next);
      return;
    }
    navigate(`${publicPath('/ricerca')}?${next.toString()}`);
  };

  return (
    <form
      className={`vc-mkt-search${compact ? ' vc-mkt-search--compact' : ''}`}
      onSubmit={handleSubmit}
    >
      <label className="vc-mkt-search__field vc-mkt-search__field--grow">
        <span>Di cosa hai bisogno</span>
        <input
          type="text"
          value={prestazione}
          onChange={(e) => setPrestazione(e.target.value)}
          placeholder="Es. Cardiologia, ortopedia…"
          autoComplete="off"
        />
      </label>
      <label className="vc-mkt-search__field">
        <span>Dove</span>
        <input
          type="text"
          value={dove}
          onChange={(e) => setDove(e.target.value)}
          placeholder="Tutta Italia / video (opzionale)"
          autoComplete="off"
        />
      </label>
      <label className="vc-mkt-search__field">
        <span>Come paghi</span>
        <select value={pagatore} onChange={(e) => setPagatore(e.target.value)}>
          {PAGATORI_ATTIVI.map((p) => (
            <option key={p.value} value={p.value}>{p.label}</option>
          ))}
        </select>
      </label>
      <button type="submit" className="vc-mkt-search__submit">
        Cerca disponibilità
      </button>
    </form>
  );
}
